import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAccount } from '@ibk/shared-auth';
import { AppDomain } from '@ibk/shared-types';
import { ContaPJNotApproved } from '../ContaPJNotApproved';
import { ContaPJPromo } from '../ContaPJPromo';
export function ContaPJGuard({ children, context = AppDomain.ESCRITORIO }) {
    const { shouldShowPromo, getPJAccountStatus, hasNotApprovedPJAccount } = useAccount();
    const notApproved = hasNotApprovedPJAccount ? (hasNotApprovedPJAccount() ?? false) : false;
    if (notApproved) {
        return _jsx(ContaPJNotApproved, { context: context });
    }
    let showPromo = false;
    try {
        showPromo = shouldShowPromo ? (shouldShowPromo() ?? false) : false;
    }
    catch {
        showPromo = false;
    }
    if (showPromo) {
        let status;
        try {
            status = getPJAccountStatus ? getPJAccountStatus() : undefined;
        }
        catch {
            status = undefined;
        }
        return _jsx(ContaPJPromo, { context: context, status: status });
    }
    return _jsx(React.Fragment, { children: children });
}
